<template>
	<!-- 礼物详情 -->
	<div class="lwInfo">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="back">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">详情</p>
				</div>
			</div>
		</van-sticky>
		<div>
			<div class="rightSelect">
				<div  @click="firstSelectBox">
					<p v-model="firstselectValue">{{firstselectValue}}</p>
					<img src="../../assets/img/selectArr.png" alt="">
				</div>
			</div>
			<div class="selectItem" v-show="firstSelect">
				<div class="selectItem_left"></div>
				<div class="selectItem_right">
					<div class="selectItem_right_title">
						<img src="../../assets/img/close.png" alt="" @click="closeFn">
						<p>全部</p>
					</div>
					<ul>
						<li v-for="(selectItem,index) in firstSelectLists" :key="index" @click="firstselectItemFn(selectItem,index)">
							<div>
								<img src="../../assets/img/datalw.png" alt="" v-show="firstselectIndex == index ? false : true" />
								<img src="../../assets/img/dataLw_active.png" alt="" v-show="firstselectIndex == index ? true : false">
							</div>
							<span :class="firstselectIndex == index ? 'active_color' : '' ">{{selectItem}}</span>
						</li>
					</ul>
				</div>
			</div>
			<!-- 列表 -->
			<div class="chongzhiBoxItem">
				<div class="itemInfoNum" v-for="(item, giftInfoidx) in giftInfoArr" :key="giftInfoidx">
					<div class="itemBox">
						<div class="itemBoxList">
							<div class="readBookNum">
								<span>{{item.name}}<img src="../../assets/img/downarr.png" alt=""  @click="tapshow(giftInfoidx,item.mark)" class="downarr"></span>
								<span>{{item.count}}</span>
							</div>
							<div class="pagelist" ref="giftInfoArrBox">
								<div v-for="(listItm,listIdx) in item.list">
									<p>
										<span class="penName">
											<span v-for="(itm,idx) in listItm.name" v-if="idx <= 6">{{itm}}</span>
										</span>
										<span>送出1个</span>
									</p>
									<p>
										<span class="timeData">
											<a href="javascript:;">{{formatDateTime(listItm.createtime)}}</a>
										</span>
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- <div class="itemInfoNum">
					<div class="itemBox">
						<div class="itemBoxList">
							<div class="readBookNum">
								<span>卫星<img src="../../assets/img/downarr.png" alt="" @click="tapshow" class="downarr"></span>
								<span>9</span>
							</div>
							<div class="pagelist" v-show="tapshowBox">
								<div>
									<p>
										<span class="penName">小猴子</span>
										<span>送出1个</span>
									</p>
									<p>
										<span class="timeData">
											<a>2020-05-14</a>
											<a>18:45:26</a>
										</span>
									</p>
								</div>
								<div>
									<p>
										<span class="penName">小猴子</span>
										<span>送出1个</span>
									</p>
									<p>
										<span class="timeData">
											<a>2020-05-14</a>
											<a>18:45:26</a>
										</span>
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>-->
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tapshowBox: true,
				firstSelect: false,
				firstselectIndex: 0, //选中索引
				firstselectValue: '不限时间',
				firstSelectLists: ["不限时间", "一周之内","一月之内", "半年之内"],
				giftId: '',
				giftInfoArr: [],
			}
		},
		created() {
			this.giftId = this.$route.query.giftId;
			this.getGiftInfo();
		},
		methods: {
			firstSelectBox() { //下拉框选项 显示 -- 1
				this.firstSelect = !this.firstSelect
			},
			tapshow(index, mark) {
				// debugger
				this.giftInfoArr[index].mark = !mark;
				this.tapshowBox = !mark;
				this.$refs.giftInfoArrBox.forEach((i, idx) => {
					if (index == idx) {
						if (this.tapshowBox == true) {
							this.$refs.giftInfoArrBox[idx].style.display = 'none';
						} else {
							this.$refs.giftInfoArrBox[idx].style.display = 'block';
						}
					}
			
				})
			},
			firstselectItemFn(value, index) { //下拉框选择 -- 1
				this.firstselectValue = value;
				this.firstselectIndex = index;
				this.firstSelect = !this.firstSelect;
				this.$axios.post(this.$api.gift_detail,
				{time: index}
				).then(res => {
					console.log(res)
					this.giftInfoArr = res.data.data;
				})
			},
			closeFn(){
				this.firstSelect = false;
			},
			// tapshow() {
			// 	this.tapshowBox = !this.tapshowBox
			// },
			back() {
				this.$router.push('/mylw')
			},
			getGiftInfo(){
				this.$axios.post(this.$api.gift_detail,
				{time: 0}
				).then(res => {
					console.log(res)
					this.giftInfoArr = res.data.data;
					this.giftInfoArr.forEach(item => {
						console.log(item)
						Object.getOwnPropertyNames(item).forEach(key => {
							item['mark'] = true;
						})
					})
				})
			},
			formatDateTime(dateNum) {
				var date = new Date(dateNum * 1000);
				return date.getFullYear() + "-" + fixZero(date.getMonth() + 1, 2) + "-" + fixZero(date.getDate(), 2) + " " +
					fixZero(date.getHours(), 2) + ":" + fixZero(date.getMinutes(), 2) + ":" + fixZero(date.getSeconds(), 2);
			
				function fixZero(num, length) {
					var str = "" + num;
					var len = str.length;
					var s = "";
					for (var i = length; i-- > len;) {
						s += "0";
					}
					return s + str;
				}
			},
		}
	}
</script>

<style lang="less" scoped>
	.lwInfo {
		height: 100vh;
		background-color: #f9f9f9;

		// 头部
		.headerBox {
			height: 160px;
			background-color: #ff4081;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
			background-size: 100%;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 80px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;

				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}

				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}

		}

		//筛选
		.rightSelect {
			background-color: #fff;
			padding: 10px 0;
			margin-bottom: 20px;

			div {
				border: 0;
				margin: 10px 16px;
				padding: 5px 20px;
				font-size: 30px;/*px*/
				border-radius: 8px;
				border: 1px solid #fa7298;/*no*/
				width: 160px;
				position: relative;

				p {
					display: inline-block;
					color: #fa7298;
				}

				img {
					width: 30px;
					position: absolute;
					right: 10px;
					top: 50%;
					transform: translateY(-50%);
				}
			}

		}

		//下拉列表
		.selectItem {
			width: 100vw;
			height: 100vh;
			overflow: hidden;
			position: absolute;
			top: 160px;
			right: 0px;
			display: flex;

			.selectItem_left {
				width: 30vw;
				background-color: rgba(0, 0, 0, .3);
			}

			.selectItem_right {
				flex: 1;
				background-color: #fff;
				.selectItem_right_title{
					height: 80px;
					line-height: 80px;
					width: 100%;
					position: relative;
					img{
						position: absolute;
						top: 50%;
						left: 20px;
						transform: translateY(-50%);
						width: 25px;
					}
					p{
						text-align: center;
						width: 100%;
						font-size: 30px;/*px*/
						font-weight: 600;
					}
				}
				ul {
					background-color: #fff;
					z-index: 1000;
					position: relative;
					padding: 0 20px;
					li {
						padding: 0px 20px;
						position: relative;
						text-align: center;
						line-height: 80px;
						color:#a3a3a3;
						display: flex;
						div{
							width: 20%;
							margin: 0 20px;
							img {
								width: 30px;
								padding-right: 10px;
								position: absolute;
								top: 50%;
								transform: translateY(-50%);
							}
						}
						span{
							flex:1;
							font-size: 30px;/*px*/
							text-align: left;
							padding-left: 40px;
							border-bottom: 1px solid #f0f0f0;
							/*no*/
						}
					}

					.active_color {
						color: #3d3d3d;
					}
				}
			}
		}

		.chongzhiBoxItem {
			padding: 0 16px;
			padding-top: 20px;
			.itemInfoNum {
				-webkit-box-shadow:  0 0 9px 0px rgba(0, 0, 0, 0.1);/*no*/
				-moz-box-shadow:  0 0 9px 0px rgba(0, 0, 0, 0.1);/*no*/
				box-shadow: 0 0 9px 0px rgba(0, 0, 0, 0.1);/*no*/
				border-radius: 15px;
				margin-bottom: 20px;
				background-color: #fff;

				.itemBox:last-child {
					.itemBoxList {
						border-bottom: 0;
					}
				}

				.itemBox {
					padding: 30px;

					.itemBoxList {
						border-bottom: 1px solid #f0f0f0;
						/*no*/

						.readBookNum {
							display: flex;

							color: #000000;
							font-size: 30px;
							/*px*/

							.downarr {
								vertical-align: middle;
								width: 25px;
								margin-left: 10px;
							}

							span {
								flex: 1;
								font-weight: 600;
							}

							span:last-child {
								flex: 1;
								text-align: right;
								color: #ff4081;
								font-weight: 400;
							}
						}

						.pagelist {
							margin-top: 15px;
							display: none;
							div {
								display: flex;

								p {
									flex: 1;
									line-height: 80px;
									text-align: center;
									font-size: 28px;
									/*px*/
									border-bottom: 1px solid #f0f0f0;

									/*no*/
									.penName {
										span{
											color: #ff4081;
										}
									}

									span {
										// padding-right: 40px;
										color: #3d3d3d;
									}

									i {
										font-style: normal;
										color: #fa7289;
										padding-right: 40px;
									}

									.timeData {
										color: #a3a3a3;
										text-align: right;
										padding: 0;

										a {
											padding-right: 10px;
										}

										a:last-of-type {
											padding-right: 0px;
										}
									}
								}
							}
						}
					}

					// 消费记录 底线
					.itemBox {
						.line:last-of-type {
							border-bottom: 0;
						}
					}

					.datatime {
						line-height: 80px;
						color: #a3a3a3;

						// border-bottom: 1px solid #f0f0f0;/*no*/
						.time {
							padding-left: 10px;
						}
					}
				}

			}

		}


	}
</style>
